var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCongptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3596_801)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3596_801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1037 6.42732H16.3428V0H0V16H16.3428V10.1203H13.1037V13.7786H3.31676V5.64131L8.37694 2.25625H13.1037V6.42732Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3596_801)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3596_801)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5829,
    cy: 1.51581,
    rx: 11.0451,
    ry: 11.0451,
    fill: "#1782FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3596_801)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.46978,
    cy: 2.89189,
    r: 10.2933,
    fill: "#50B7F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3596_801)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.87477,
    cy: 16.8875,
    rx: 8.64138,
    ry: 8.64138,
    fill: "#DC45EE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3596_801)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.4657,
    cy: 15.4935,
    r: 10.0355,
    fill: "url(#paint0_linear_3596_801)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3596_801",
    x: -0.462158,
    y: -19.5293,
    width: 42.0901,
    height: 42.0898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_3596_801"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3596_801",
    x: -12.8235,
    y: -17.4014,
    width: 40.5864,
    height: 40.5869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_3596_801"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3596_801",
    x: -11.7666,
    y: -1.75391,
    width: 37.2827,
    height: 37.2832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_3596_801"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3596_801",
    x: 0.430176,
    y: -4.54199,
    width: 40.071,
    height: 40.0713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_3596_801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3596_801",
    x1: 10.4302,
    y1: 7.13059,
    x2: 33.0498,
    y2: 11.6763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3596_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3428,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCongptIcon);
export default __webpack_public_path__ + "static/media/chatCongptIcon.af0d29f6cbdeef8721625015e6eb6519.svg";
export { ForwardRef as ReactComponent };